import { Tooltip as MuiTooltip } from '@mui/material';
import UntitledIcon from '@payaca/untitled-icons';
import React, { FC, type JSX } from 'react';
import './Tooltip.sass';

type Props = {
  text: string | JSX.Element;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  children?: JSX.Element;
};
const Tooltip: FC<React.PropsWithChildren<Props>> = ({
  text,
  placement = 'top',
  children,
}: React.PropsWithChildren<Props>) => {
  return (
    <MuiTooltip
      title={text}
      arrow
      placement={placement}
      className="tooltip-wrapper"
      enterTouchDelay={0}
    >
      <span>
        {children || (
          <span className="info-circle-container tooltip-icon">
            <UntitledIcon name="info-circle.3" />
          </span>
        )}
      </span>
    </MuiTooltip>
  );
};

export default Tooltip;
